import React from 'react';
import { LayersIcon, ClipboardCheckIcon, LayoutGridIcon, PrinterIcon, GiftIcon, FolderOpenIcon, TimerIcon } from 'lucide-react';
import { benefits } from '../data/content';
const icons = [{
  Icon: LayersIcon,
  color: 'text-brand'
}, {
  Icon: ClipboardCheckIcon,
  color: 'text-goldDark'
}, {
  Icon: LayoutGridIcon,
  color: 'text-check'
}, {
  Icon: PrinterIcon,
  color: 'text-brand'
}, {
  Icon: GiftIcon,
  color: 'text-goldDark'
}, {
  Icon: FolderOpenIcon,
  color: 'text-navy'
}, {
  Icon: TimerIcon,
  color: 'text-check'
}];
export function BenefitsGrid() {
  return <section className="bg-pale px-4 py-6 text-center md:px-12 md:py-8" data-id="element-1" data-mp="9yh5nd7zl1le">
      <h2 className="mx-auto max-w-[620px] font-heading text-[21px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-navy md:text-[26px]" data-id="element-2" data-mp="9we8884i866n">
        This is not another basic AAC book filled with theory.
      </h2>
      <p className="mx-auto mt-1.5 max-w-[620px] font-heading text-[13px] font-bold uppercase leading-tight text-brand md:text-[16px]" data-id="element-3" data-mp="3s3tx8bjsh2mr">
        It's an organized collection of advanced clinical materials.
      </p>
      <div className="mt-3 grid gap-2 text-left sm:grid-cols-2" data-id="element-4" data-mp="2bifp7i8vjn5v">
        {benefits.map((b, i) => {
        const {
          Icon,
          color
        } = icons[i];
        const isLastOdd = i === benefits.length - 1 && benefits.length % 2 === 1;
        return <article key={b.title} className={`flex gap-2.5 rounded-md border border-line bg-white p-3 ${isLastOdd ? 'sm:col-span-2' : ''}`} data-id="element-5" data-mp="21q9x88imh5qo" data-mpi={i}>
              <Icon className={`mt-0.5 h-[18px] w-[18px] shrink-0 ${color}`} strokeWidth={2.5} aria-hidden data-id="element-6" data-mp="2ug8tanv8i34u" />
              <div data-id="element-7" data-mp="2gjbsbtlej5a8">
                <h3 className="font-heading text-[14px] font-bold leading-tight text-navy md:text-[15px]" data-id="element-8" data-mp="2kiudmqh4xidl">{b.title}</h3>
                <p className="mt-1 text-[13px] leading-[1.4] text-ink md:text-[14px]" data-id="element-9" data-mp="151kigr2akt8x">{b.text}</p>
              </div>
            </article>;
      })}
      </div>
      <p className="mt-3.5 font-heading text-[13px] font-extrabold uppercase leading-tight text-goldDark md:text-[15px]" data-id="element-10" data-mp="191clko8x276w">
        One complete professional collection.
      </p>
    </section>;
}